import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type Item from '~/stores/models/Item'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionProcessingShowcase',
  setup(__props) {


const collections = useCollectionsStore()

const showcaseLinkHint = ref('')

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text).then(() => {
    // Success! Show a hint
    showcaseLinkHint.value = 'Copied showcase link to clipboard!'
    // Hide the hint after 5 seconds
    setTimeout(() => { showcaseLinkHint.value = '' }, 5000)
  }).catch((err) => {
    // Handle error
    console.error('Failed to copy: ', err)
  })
}

const validator = (item: Item) => {
  return item.item_attributes.published ? '' : 'Not published to websites'
}


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_CollectionProcessingDialog = _resolveComponent("CollectionProcessingDialog")!

  return (_openBlock(), _createBlock(_component_CollectionProcessingDialog, {
    validator: validator,
    reorderable: ""
  }, {
    options: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-4" }, " A link to a showcase page with the companies below will be generated. You can provide an optional title for the page. Any companies that are not being published to SOSV websites will be excluded from the showcase. You can remove and reorder companies before continuing. ", -1)),
      _createVNode(_component_v_text_field, {
        modelValue: _unref(collections).processOptions.showcaseTitle,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(collections).processOptions.showcaseTitle) = $event)),
        label: "Showcase Title (optional)",
        variant: "solo-filled",
        flat: "",
        "hide-details": ""
      }, null, 8, ["modelValue"])
    ]),
    results: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        modelValue: _unref(collections).processResult,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(collections).processResult) = $event)),
        label: "Showcase Link",
        variant: "solo-filled",
        hint: _unref(showcaseLinkHint),
        "persistent-hint": "",
        readonly: ""
      }, {
        append: _withCtx(() => [
          _createVNode(_component_hy_icon, {
            name: "Clipboard",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(_unref(collections).processResult))),
            small: ""
          })
        ]),
        _: 1
      }, 8, ["modelValue", "hint"])
    ]),
    _: 1
  }))
}
}

})